/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Comment_PlaceholderInputs */

const es_feedback_modal_comment_placeholder = /** @type {(inputs: Feedback_Modal_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe el detalle de tu feedback...`)
};

const en_feedback_modal_comment_placeholder = /** @type {(inputs: Feedback_Modal_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your feedback in detail...`)
};

/**
* | output |
* | --- |
* | "Describe your feedback in detail..." |
*
* @param {Feedback_Modal_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_comment_placeholder = /** @type {((inputs?: Feedback_Modal_Comment_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Comment_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_comment_placeholder(inputs)
	return en_feedback_modal_comment_placeholder(inputs)
});
export { feedback_modal_comment_placeholder as "feedback.modal.comment_placeholder" }